import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  Button,
  useTheme,
  alpha,
  FormControl,
} from '@mui/material';
import {
  Visibility,
  Security,
  Save,
} from '@mui/icons-material';

export function Privacy() {
  const theme = useTheme();

  return (
    <Box sx={{ maxWidth: '800px' }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={800} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Security color="primary" sx={{ fontSize: '2.5rem' }} /> Profile Visibility
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Control who can see your personal identity details across the platform.
        </Typography>
      </Box>

      <TableContainer component={Paper} elevation={0} sx={{ 
        mb: 4, 
        borderRadius: '20px', 
        border: '1px solid', 
        borderColor: 'divider',
        overflow: 'hidden'
      }}>
        <Table>
          <TableHead sx={{ bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 800, fontSize: '1rem', py: 2.5 }}>Details</TableCell>
              <TableCell sx={{ fontWeight: 800, fontSize: '1rem', py: 2.5 }}>Visibility Setting</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow hover>
              <TableCell sx={{ fontWeight: 600, color: 'text.secondary' }}>First Name</TableCell>
              <TableCell>
                <Typography variant="body2" fontWeight={700} color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Visibility fontSize="small" /> Public
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell sx={{ fontWeight: 600, color: 'text.secondary' }}>Last Name</TableCell>
              <TableCell>
                <FormControl fullWidth size="small">
                  <Select defaultValue="Public" sx={{ borderRadius: '12px', fontWeight: 600 }}>
                    <MenuItem value="Public">Public</MenuItem>
                    <MenuItem value="All Members">All Members</MenuItem>
                    <MenuItem value="My Connections">My Connections</MenuItem>
                    <MenuItem value="Only Me">Only Me</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell sx={{ fontWeight: 600, color: 'text.secondary' }}>Nickname</TableCell>
              <TableCell>
                <FormControl fullWidth size="small">
                  <Select defaultValue="Public" sx={{ borderRadius: '12px', fontWeight: 600 }}>
                    <MenuItem value="Public">Public</MenuItem>
                    <MenuItem value="All Members">All Members</MenuItem>
                    <MenuItem value="My Connections">My Connections</MenuItem>
                    <MenuItem value="Only Me">Only Me</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button 
          variant="contained" 
          size="large" 
          startIcon={<Save />}
          sx={{ px: 8, py: 1.5, borderRadius: '50px', fontWeight: 800, boxShadow: '0 8px 25px rgba(212, 175, 55, 0.2)' }}
        >
          Save Visibility Settings
        </Button>
      </Box>
    </Box>
  );
}
